import { createSessionIdStorage } from '@orionprotocol/storage';

import { keyValueStorage } from './defaultKeyValueStorage';

export const sessionIdStorage = createSessionIdStorage(keyValueStorage);
